import React from "react";
// import {  CheckSquare } from 'feather-icons-react';
import { Container, Col, Row, Card, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "../../../components/SplitNumber";
import { IconCheck } from "../../../../assets/icons";

function SuccessPaymentWallet(props) {
  return (
    <>
      <Container className="my-auto text-center" style={{ maxWidth: "500px" }}>
        <Card className="rounded-4 ">
          <Card.Body>
            <div className="bg-success justify-content-center rounded-3 text-center py-2">
              <span className="text-white"> پرداخت موفقیت آمیز بود </span>
            </div>
            <Row className="justify-content-center mt-3 ">
              <Col
                xs="12"
                className=" d-flex justify-content-center mt-4 large-icons"
              >
                <IconCheck fillColor="#09a463" />
              </Col>
              <Col xs="12" className=" d-flex justify-content-center mt-3 ">
                <span className="text-success font-weight-bold">
                  {" "}
                  پرداخت با موفقیت انجام شد.
                </span>
              </Col>
            </Row>

            <Row className=" mt-4 ">
              <Col xs="12" className="">
                <Alert variant="primary" className="rounded-4">
                  شما اکنون مبلغ{" "}
                  <span className="fs-101 fw-bold">
                    <SplitNumber number={props.amount}></SplitNumber> تومان{" "}
                  </span>{" "}
                  پرداخت کردید.
                </Alert>
              </Col>
              <Col xs="12" className=" py-2 fs-101">
                <span className="me-2">شماره پیگیری : </span>{" "}
                <span className="ms-2 fw-bold">{props.referenceId}</span>
              </Col>
              <Col xs="12" className=" py-2 fs-101">
                <span className="me-2"> موجودی کیف پول : </span>{" "}
                <span className="ms-2 fw-bold">
                  <SplitNumber
                    number={props.userWalletRiallBalance}
                  ></SplitNumber>{" "}
                  تومان
                </span>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default SuccessPaymentWallet;
